import { Component, computed, inject, input, signal } from "@angular/core";
import { AppConfigService } from "@kno2/core/config";
import { DynamicDialogConfig } from "primeng/dynamicdialog";

@Component({
    selector: "kno2-onboarding-modal-header",
    imports: [],
    templateUrl: "./onboarding-modal-header.component.html",
    host: {
        style: "display: block; width: 100%;"
    }
})
export class OnboardingModalHeaderComponent {
    private static readonly KNO2_CONNECTED_LOGO_URL = "https://assets.kno2fy.com/Kno2Connected_Blue.png";

    private readonly dialogConfig = inject(DynamicDialogConfig, { optional: true });
    private readonly webConfig = inject(AppConfigService).webConfig;

    public readonly headerTitle = input<string>("");

    protected readonly actualHeaderTitle = computed(() => this.headerTitle() || this.dialogConfig?.data?.header?.headerText || "");

    protected readonly showLeftLogo = computed(() => this.dialogConfig?.data?.dialogId !== "reseller-terms-and-conditions-modal");
    protected readonly logoUrl = signal(this.webConfig.images?.find((image) => image.name === "logo-dark")?.url || "");
    protected readonly kno2ConnectedLogoUrl = signal(OnboardingModalHeaderComponent.KNO2_CONNECTED_LOGO_URL);
}
